import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import { RiH1, RiH2, RiH3, RiH4, RiH5, RiH6 } from 'react-icons/ri';

import NewDropDown from './NewDropDown';

export default function HeadingFormatter({ editor, tooltipText, ...props }) {
  const handleClickOption = useCallback(level => editor.chain().focus().toggleHeading({ level }).run(), [editor])

  const ActiveIcon = SIZES.find(size => editor.isActive('heading', { level: size.value }))

  return <NewDropDown
    options={SIZES}
    onClickOption={handleClickOption}
    tooltipText={tooltipText}
    icon={ActiveIcon ? ActiveIcon.icon : RiH1}
    {...props}
  />
}

const SIZES = [{ value: 1, icon: RiH1 }, { value: 2, icon: RiH2 }, { value: 3, icon: RiH3 }, { value: 4, icon: RiH4 }, { value: 5, icon: RiH5 }, { value: 6, icon: RiH6 }]

HeadingFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
